module.exports = ['$sce', '$filter', function ($sce, $filter) {
    return {
        restrict: "A",
        templateUrl: '/static/partials/components/editable_table_cell.html',
        scope: {
            pdEditObject: "=",
            pdEditAttribute: '@',
            pdDisplay: "=?",
            pdDisplayFn: "&?",
            pdEditable: '=',
            pdShowAction: '=',
            pdValueChanged: "&",
            pdFocus: '&?',
            pdBlur: '&?',
            pdSubmitAction: '&?'
        },
        replace: true,
        transclude: true,
        link: function link($scope, $element, $attrs) {
            $scope.getAttrDislpay = function () {
                if($scope.pdDisplay != undefined) {
                    return $sce.trustAsHtml($scope.pdDisplay);
                }
            }
        }
    };
}];